export default {
    state: {
        // 登录状态是否改变
        loginStatus: false,
    },
    getters: {

    },
    mutations: {
      editLoginStatus(state) {
        state.loginStatus = true;
      },
    },
    actions: {

    }
};


// WEBPACK FOOTER //
// ./src/store/modules/login.js